import { withStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import Notification from './Notification';
import { globalStyles as styles } from './style/gstheme';
import { MEDIA_TYPES } from './utils/constants';
import remarkGfm from 'remark-gfm';

class ContentDisplay extends React.Component {

    constructor(props) {
        super(props);
        let domPurifyOptions = {};
        this.state = {
            imageError: false,
            originalText: props.text,
            renderImage: true,
            waitForImage: false,
            domPurifyOptions
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.treatContentAs === MEDIA_TYPES.IMAGES && props.text !== state.originalText) {
            return {
                waitForImage: true,
                originalText: props.text,
                renderImage: false
            };
        }
        return null;
    }

    componentDidUpdate() {
        if (this.state.waitForImage) {
            clearTimeout(this.idleTimeout);
            this.idleTimeout = setTimeout(this.updateImage, 1000);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.idleTimeout);
    }

    updateImage = () => this.setState({renderImage: true, waitForImage: false, imageError: false});

    loadImageError = () => this.setState({ imageError: true });

    render() {

        const { treatContentAs, text, maxHeight, overrideMediaType } = this.props;
        const { imageError, domPurifyOptions, renderImage } = this.state;

        let actualMediaType = treatContentAs;
        // We sniff the content for clues as to actual media type
        if (overrideMediaType) {
            // If starts http only option is really an image link
            if (text.indexOf("http") === 0) {
                actualMediaType = MEDIA_TYPES.IMAGES;
            }
            else if (text.indexOf("<svg") >= 0) {
                actualMediaType = MEDIA_TYPES.SVG;
            }
            else if (text.indexOf("<math") >= 0) {
                actualMediaType = MEDIA_TYPES.MATHML;
            }
            // Otherwise look for clues it is HTML
            else if (text.indexOf("<div") >= 0 || text.indexOf("<p") >= 0
                || text.indexOf("<ul") >= 0 || text.indexOf("<ol") >= 0
                || text.indexOf("<blockquote") >= 0 || text.indexOf("<img") >= 0
                || text.indexOf("<em") >= 0 || text.indexOf("<b") >= 0
                || text.indexOf("<i") >= 0 || text.indexOf("<sup") >= 0
                || text.indexOf("<sub") >= 0) {
                actualMediaType = MEDIA_TYPES.HTML;
            }
            // Failing that assume it's markdown
            else actualMediaType = MEDIA_TYPES.MARKDOWN;
        }

        let displayImage = renderImage;
        if (actualMediaType === MEDIA_TYPES.IMAGES) {
            try {
                new URL(text);
                if (text.match(/\..{2}.*\/.{3}/) === null) {
                    displayImage = false;
                }
            }
            catch (e) {
                displayImage = false;
            }
        }

        return (
            <div style={{
                fontSize: 12,
                textAlign: actualMediaType === MEDIA_TYPES.IMAGES ?
                    'center'
                    :
                    'left'
            }}>
                {actualMediaType === MEDIA_TYPES.MARKDOWN &&
                    <div data-test="markdown-content"
                        style={{
                            paddingRight: '6px',
                            maxHeight
                        }}>
                        <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                            children={text}
                            skipHtml={true} />
                    </div>
                }
                {[MEDIA_TYPES.MATHML, MEDIA_TYPES.SVG, MEDIA_TYPES.HTML].includes(actualMediaType) &&
                    <div
                        data-test="markup-content"
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            ...(treatContentAs === MEDIA_TYPES.SVG) && { maxHeight: maxHeight + 4, maxWidth: maxHeight }
                        }}>{parse(DOMPurify.sanitize(text, domPurifyOptions))}</div>
                }
                {actualMediaType === MEDIA_TYPES.IMAGES &&
                    <div>
                        {imageError ?
                            <Notification error={false} text="The image could not be loaded." dataTest="not-loaded" />
                            :
                            !displayImage || text === "" ?
                                <Notification error={false} text="Image will be displayed when text entered." dataTest="when-text-entered" />
                                :
                                <img
                                    data-test="image-link-img"
                                    style={{
                                        maxHeight,
                                        maxWidth: maxHeight,
                                        borderRadius: 4,
                                        boxShadow: '0px 6px 6px #00000024',
                                    }}
                                    alt=""
                                    onError={this.loadImageError}
                                    src={text} />
                        }
                    </div>
                }
            </div>
        );
    }
}

ContentDisplay.defaultProps = {
    maxHeight: '180px',
    overrideMediaType: false
};

ContentDisplay.propTypes = {
    overrideMediaType: PropTypes.bool,
    treatContentAs: PropTypes.string,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    classes: PropTypes.object
};

export default withStyles(styles)(ContentDisplay);